import { PermissionFileGroup } from '@orgbrain/roles';
import { BOARDMEETING_STATUS } from './lib-admin';
import { DirentNameEnum, MeetingType } from '@orgbrain/lib-data';

export type FilePermsBrief = 'RW' | 'R' | 'W';
export type ACLBrief = { [group in PermissionFileGroup]: FilePermsBrief };

export type FileSystemTemplateNode = {
  name?: string;
  nameType?: DirentNameEnum; // default to  DirentNameEnum.KEY_MUTABLE if unset
  acl?: Partial<ACLBrief>;
  ecl?: Partial<ACLBrief>;
  scl?: Partial<ACLBrief>;
  children?: FileSystemTemplateNode[];
  systemFolder?: boolean; // System folders are not displayed in the Dataroom UI
};

export enum FileFolderEnum {
  ATTACHMENTS = 'ATTACHMENTS',
  MINUTES = 'MINUTES',
  PROXY_FOLDER = 'PROXY_FOLDER',
  MINUTES_ATTACHMENTS = 'MINUTES_ATTACHMENTS',
}

export class FileMetaData {
  // This overlaps with FileInfo  they seem tpo be used interchangebly. TODO tidy up
  orgId: string;
  meetingId: string;
  meetingType?: MeetingType;
  folder: FileFolderEnum;
  name?: string;
  createdBy?: string;
  direntId?: string;
  newMeetingStatus?: BOARDMEETING_STATUS;
  isAdmin?: boolean;
  fileSize?: number;
}

export class FileInfo {
  _id?: string;
  name: string;
  orgId?: string;
  meetingId?: string;
  fullpath?: string;
  folder?: string;
  mode?: number;
  size?: number;
  atime?: string;
  mtime?: string;
  ctime?: string;
  isDir?: boolean;
  summary?: any;
  deleted?: boolean; // USED to avoid having to refresh
  status?: any;
  direntId?: string;
  createdAt?: Date;
  contentType?: string;
}

export function fileContainsPDF(contentType: string) {
  return contentType?.startsWith('%PDF-') || contentType === 'application/pdf';
}
